import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { ErrorCodeTranslationService } from '../services/errorcode-translation.service';
import { DetailAhaGoldDialogComponent } from './aha-upgrade-prompts/detail/detail-aha-gold-dialog/detail-aha-gold-dialog.component';
import { DetailAhaGoldLeftPanelComponent } from './aha-upgrade-prompts/detail/detail-aha-gold-prompt/components/detail-aha-gold-left-panel/detail-aha-gold-left-panel.component';
import { DetailAhaGoldRightPanelComponent } from './aha-upgrade-prompts/detail/detail-aha-gold-prompt/components/detail-aha-gold-right-panel/detail-aha-gold-right-panel.component';
import { DetailAhaGoldPromptComponent } from './aha-upgrade-prompts/detail/detail-aha-gold-prompt/detail-aha-gold-prompt.component';
import { EarlyAccessAhaGoldDialogComponent } from './aha-upgrade-prompts/early-access/early-access-aha-gold-dialog/early-access-aha-gold-dialog.component';
import { EarlyAccessAhaGoldLeftPanelComponent } from './aha-upgrade-prompts/early-access/early-access-aha-gold-prompt/components/early-access-aha-gold-left-panel/early-access-aha-gold-left-panel.component';
import { EarlyAccessAhaGoldRightPanelComponent } from './aha-upgrade-prompts/early-access/early-access-aha-gold-prompt/components/early-access-aha-gold-right-panel/early-access-aha-gold-right-panel.component';
import { EarlyAccessAhaGoldPromptComponent } from './aha-upgrade-prompts/early-access/early-access-aha-gold-prompt/early-access-aha-gold-prompt.component';
import { GenericAhaGoldDialogComponent } from './aha-upgrade-prompts/generic/generic-aha-gold-dialog/generic-aha-gold-dialog.component';
import { GenericAhaGoldLeftPanelComponent } from './aha-upgrade-prompts/generic/generic-aha-gold-prompt/components/generic-aha-gold-left-panel/generic-aha-gold-left-panel.component';
import { GenericAhaGoldRightPanelComponent } from './aha-upgrade-prompts/generic/generic-aha-gold-prompt/components/generic-aha-gold-right-panel/generic-aha-gold-right-panel.component';
import { GenericAhaGoldPromptComponent } from './aha-upgrade-prompts/generic/generic-aha-gold-prompt/generic-aha-gold-prompt.component';
import { AlphanumericKeypadComponent } from './app-keyboards/alphanumeric-keypad/alphanumeric-keypad.component';
import { NumericKeypadComponent } from './app-keyboards/numeric-keypad/numeric-keypad.component';
import { CastComponent } from './cast/cast.component';
import { ContentDetailComponent } from './content-detail/content-detail.component';
import { AwaitingPaymentComponent } from './dialogs/awaiting-payment/awaiting-payment.component';
import { SendLinkConfirmationComponent } from './dialogs/send-link-confirmation/send-link-confirmation.component';
import { DisplayInfoComponent } from './display-info/display-info.component';
import { ExitAppComponent } from './exit-app-and-sign-out/exit-app/exit-app.component';
import { SignOutComponent } from './exit-app-and-sign-out/sign-out/sign-out.component';
import { IconButtonComponent } from './icon-button/icon-button.component';
import { IconComponent } from './icon/icon.component';
import { CardsComponent } from './list-view/card/cards.component';
import { GridComponent } from './list-view/grid/grid.component';
import { NoInternetComponent } from './no-internet/no-internet.component';
import { ParentalPinComponent } from './parental-pin/parental-pin.component';
import { PinInputComponent } from './parental-pin/pin-input/pin-input.component';
import { PlayerErrorComponent } from './player-prompts/player-error-dialog/player-error.component';
import { ActiveSubscriptionComponent } from './subscription-alerts/active-subscription/active-subscription.component';
import { PreviewCompleteComponent } from './subscription-alerts/free-preview-complete/preview-complete.component';
import { NoActiveSubscriptionComponent } from './subscription-alerts/no-active-subscription/no-active-subscription.component';
import { TagsComponent } from './tags/tags.component';
import { ToastComponent } from './toast/toast.component';
import { RentToWatchComponent } from './tvod/rent-to-watch/rent-to-watch.component';
import { InAppBannerComponent } from './in-app-banner/in-app-banner.component';
import { PaymentNotAllowedComponent } from './subscription-alerts/payment-not-allowed/payment-not-allowed.component';
import { CanceledComponent } from './subscription-alerts/canceled/canceled';
import { ModalSubComponent } from './dialogs/modal-sub/modal-sub.component';
import { NgxKjuaModule } from 'ngx-kjua';
import { TvodPaymentNotAllowedComponent } from './subscription-alerts/tvod-payment-not-allowed/tvod-payment-not-allowed.component';
import { StorefrontHorizontalCarouselComponent } from './list-view/storefront-horizontal-carousel/storefront-horizontal-carousel.component';
import { HorizontalCarouselComponent } from './list-view/horizontal-carousel/horizontal-carousel.component';
import { SessionTimeoutComponent } from './session-timeout/session-timeout.component';

@NgModule({
  declarations: [
    IconComponent,
    IconButtonComponent,
    ParentalPinComponent,
    NumericKeypadComponent,
    AlphanumericKeypadComponent,
    PinInputComponent,
    PlayerErrorComponent,
    PreviewCompleteComponent,
    NoActiveSubscriptionComponent,
    ExitAppComponent,
    ContentDetailComponent,
    TagsComponent,
    CardsComponent,
    HorizontalCarouselComponent,
    StorefrontHorizontalCarouselComponent,
    CastComponent,
    DisplayInfoComponent,
    GridComponent,
    ToastComponent,
    SignOutComponent,
    GenericAhaGoldPromptComponent,
    GenericAhaGoldDialogComponent,
    GenericAhaGoldLeftPanelComponent,
    GenericAhaGoldRightPanelComponent,
    EarlyAccessAhaGoldDialogComponent,
    EarlyAccessAhaGoldLeftPanelComponent,
    EarlyAccessAhaGoldRightPanelComponent,
    EarlyAccessAhaGoldPromptComponent,
    DetailAhaGoldDialogComponent,
    DetailAhaGoldLeftPanelComponent,
    DetailAhaGoldRightPanelComponent,
    DetailAhaGoldPromptComponent,
    RentToWatchComponent,
    ActiveSubscriptionComponent,
    SendLinkConfirmationComponent,
    AwaitingPaymentComponent,
    NoInternetComponent,
    InAppBannerComponent,
    PaymentNotAllowedComponent,
    CanceledComponent,
    ModalSubComponent,
    TvodPaymentNotAllowedComponent,
    SessionTimeoutComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatSnackBarModule,
    TranslateModule,
    NgxKjuaModule,
  ],
  providers: [ErrorCodeTranslationService],
  exports: [
    IconComponent,
    IconButtonComponent,
    ParentalPinComponent,
    NumericKeypadComponent,
    AlphanumericKeypadComponent,
    PlayerErrorComponent,
    PreviewCompleteComponent,
    NoActiveSubscriptionComponent,
    ExitAppComponent,
    CardsComponent,
    HorizontalCarouselComponent,
    StorefrontHorizontalCarouselComponent,
    ContentDetailComponent,
    CastComponent,
    DisplayInfoComponent,
    GridComponent,
    SignOutComponent,
    GenericAhaGoldDialogComponent,
    EarlyAccessAhaGoldDialogComponent,
    DetailAhaGoldDialogComponent,
    RentToWatchComponent,
    ActiveSubscriptionComponent,
    SendLinkConfirmationComponent,
    AwaitingPaymentComponent,
    NoInternetComponent,
    InAppBannerComponent,
    PaymentNotAllowedComponent,
    CanceledComponent,
    ModalSubComponent,
    TvodPaymentNotAllowedComponent,
    SessionTimeoutComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedComponentsModule {}
